// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-module__password--2P9sd{padding-right:50px;background:url(/img/icons/lock.png) no-repeat;background-position:95% 50%;-webkit-background-size:20px 20px;-moz-background-size:20px;background-size:20px}\n", ""]);
// Exports
exports.locals = {
	"password": "input-module__password--2P9sd"
};
module.exports = exports;
